"use client";

import { c as _c } from "react/compiler-runtime";
import { IconBellOutline18 } from "nucleo-ui-outline-18";
import { useNotificationStore } from "@/stores/notificationStore";
import { NotificationItem } from "./NotificationItem";
interface NotificationPanelProps {
  onMarkRead: (id: string) => void;
  onMarkAllRead: () => void;
  onNavigate?: () => void;
}
export function NotificationPanel(t0) {
  const $ = _c(17);
  const {
    onMarkRead,
    onMarkAllRead,
    onNavigate
  } = t0;
  const notifications = useNotificationStore(_temp);
  const unreadCount = useNotificationStore(_temp2);
  const isLoading = useNotificationStore(_temp3);
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex items-center justify-center py-8"><p className="body-sm">Loading...</p></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (notifications.length === 0) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex flex-col items-center justify-center gap-2 py-8"><IconBellOutline18 className="dark:text-ds-text-subtle h-8 w-8 text-zinc-300" /><p className="body-sm">No notifications yet</p></div>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== onMarkAllRead || $[3] !== unreadCount) {
    t1 = unreadCount > 0 && <div className="border-ds-border-default flex shrink-0 items-center justify-between border-b px-3 pb-2"><span className="label-xs">{unreadCount} unread</span><button onClick={onMarkAllRead} className="text-xs font-medium text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300">Mark all read</button></div>;
    $[2] = onMarkAllRead;
    $[3] = unreadCount;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== notifications || $[6] !== onMarkRead || $[7] !== onNavigate) {
    let t3;
    if ($[9] !== onMarkRead || $[10] !== onNavigate) {
      t3 = notification => <NotificationItem key={notification.id} notification={notification} onMarkRead={onMarkRead} onNavigate={onNavigate} />;
      $[9] = onMarkRead;
      $[10] = onNavigate;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = notifications.map(t3);
    $[5] = notifications;
    $[6] = onMarkRead;
    $[7] = onNavigate;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = <div className="min-h-0 flex-1 overflow-y-auto">{t2}</div>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t1 || $[15] !== t3) {
    t4 = <div className="flex min-h-0 flex-1 flex-col">{t1}{t3}</div>;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
function _temp3(state_1) {
  return state_1.isLoading;
}
function _temp2(state_0) {
  return state_0.unreadCount;
}
function _temp(state) {
  return state.notifications;
}